import { useState } from 'react';
import CampaignCard from '@/components/feature/CampaignCard';
import type { Campaign } from '@/mocks/campaigns';

interface ProfileCampaignsProps {
  campaigns: Campaign[];
  creatorName: string;
}

const ProfileCampaigns = ({ campaigns, creatorName }: ProfileCampaignsProps) => {
  const [filter, setFilter] = useState<'all' | 'active' | 'completed'>('all');

  const filtered = campaigns.filter((c) => {
    if (filter === 'active') return c.daysLeft > 0;
    if (filter === 'completed') return c.daysLeft === 0;
    return true;
  });

  const tabs = [
    { id: 'all', label: 'جميع الحملات', count: campaigns.length },
    { id: 'active', label: 'نشطة', count: campaigns.filter((c) => c.daysLeft > 0).length },
    { id: 'completed', label: 'مكتملة', count: campaigns.filter((c) => c.daysLeft === 0).length },
  ];

  return (
    <div className="bg-white rounded-2xl border border-stone-100 p-6">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-lg font-black text-stone-800">حملات {creatorName}</h2>
        <span className="text-sm text-stone-400">{campaigns.length} حملة</span>
      </div>

      {/* Filter Tabs */}
      <div className="flex items-center gap-1 bg-stone-100 rounded-xl p-1 mb-6 w-fit">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setFilter(tab.id as typeof filter)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              filter === tab.id
                ? 'bg-white text-stone-800 shadow-sm'
                : 'text-stone-500 hover:text-stone-700'
            }`}
          >
            {tab.label}
            <span className={`text-xs px-1.5 py-0.5 rounded-full ${
              filter === tab.id ? 'bg-emerald-100 text-emerald-700' : 'bg-stone-200 text-stone-500'
            }`}>
              {tab.count}
            </span>
          </button>
        ))}
      </div>

      {/* Campaigns Grid */}
      {filtered.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((campaign) => (
            <CampaignCard key={campaign.id} campaign={campaign} />
          ))}
        </div>
      ) : (
        <div className="text-center py-12">
          <div className="w-16 h-16 flex items-center justify-center bg-stone-100 rounded-2xl mx-auto mb-3">
            <i className="ri-inbox-line text-2xl text-stone-400"></i>
          </div>
          <p className="text-stone-500 text-sm">لا توجد حملات في هذا القسم</p>
        </div>
      )}
    </div>
  );
};

export default ProfileCampaigns;
